export default __webpack_public_path__ + "static/media/bs.929b1134.svg";